export const saveEmail = async (email) => {
  console.log("Submitting email:", email);

  try {
    const response = await fetch("https://us-central1-yusef-b9696.cloudfunctions.net/addEmail", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        data: {
          email: email,
        },
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: "No JSON response" }));
      console.error("Error response from server:", errorData);
    } else {
      const data = await response.json();
      console.log("Success:", data);
    }

  } catch (error) {
    console.error("Error saving email:", error);
  }
};

export const saveContactInquiry = async ({ firstName, lastName, email, projectDetails, selectedServices = [] }) => {
  const response = await fetch("https://us-central1-yusef-b9696.cloudfunctions.net/addContactInquiry", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      data: {
        firstName,
        lastName,
        email,
        projectDetails,
        selectedServices,
      },
    }),
  });

  const responseBody = await response.json().catch(() => ({ data: { message: "Unknown server response" } }));

  if (!response.ok) {
    throw new Error(responseBody?.data?.message || "Unable to submit inquiry.");
  }

  return responseBody;
};
